import React, { Component } from "react";
import { Button, Divider, Modal, message } from "antd";
import { parse, stringify } from "qs";
import { connect } from "dva";
import { router } from "umi";
import EditModal from "../components/EditModal";
import MemberModal from "../components/SelectMemberModal";
import NormModal from "../components/SelectNormModal";
import PersonalNormModal from "../components/SelectPersonalNormModal";
import TargetModal from "../components/SelectTargetModal";
import Container from "../../../../../components/Container";
import ListPage from "../../../../../components/ListPage";
import OperateDropdown from "../../../../../components/OperateDropdown";
import styles from "./index.less";
// import { clearWidgetRelations } from '@/pages/Workflow/utils/formConfig';

const { confirm } = Modal;
const { ListTable } = ListPage;

@connect(({ evaluateSetting }) => ({
  ...evaluateSetting
}))
class EvaluateSettingView extends Component {
  constructor(props) {
    super(props);
    const columns = [
      {
        title: "评估组名称",
        dataIndex: "groupName",
        width: "80%"
      },
      {
        title: "操作",
        dataIndex: "",
        render: record => {
          const data = [
            {
              text: (
                <a
                  onClick={event =>
                    this.handleRename({ visible: true, record, event })
                  }
                >
                  重命名
                </a>
              )
            },
            {
              text: (
                <a
                  onClick={() =>
                    this.handleShowMemberModal({ visible: true, record })
                  }
                >
                  评估组人员
                </a>
              )
            },
            {
              text: (
                <a
                  onClick={() =>
                    this.handleShowTargetModal({ visible: true, record })
                  }
                >
                  评估对象
                </a>
              )
            },
            {
              text: (
                <a
                  onClick={() =>
                    this.handleShowNormModal({ visible: true, record })
                  }
                >
                  通用评估指标
                </a>
              )
            },
            {
              text: (
                <a
                  onClick={() =>
                    this.handleShowPersonalNormModal({ visible: true, record })
                  }
                >
                  个性化评估指标
                </a>
              )
            },
            {
              text: <a onClick={() => this.handleJump(record)}>评估进度</a>
            },
            {
              text: <a onClick={() => this.handleDelete(record)}>删除</a>
            }
          ];
          return <OperateDropdown data={data} />;
        }
      }
    ];

    const { search } = window.location;
    const query = parse(search.split("?").pop());
    const { currentProjectId } = query;

    this.state = {
      columns,
      isAdd: true,
      showAddModal: false,
      formData: {
        name: ""
      },

      currentProjectId,
      currentUserGroupId: "", // 当前评估组id
      userIds: [], // 已选择的人员列表
      targetIds: [], // 已选择的人员列表

      showMemberModal: false, // 展示评估人员modal
      showNormModal: false, // 通用指标
      showPersonalNormModal: false, // 个性化指标
      showTargetModal: false
    };
  }

  componentDidMount() {
    this.getList();
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const params = { page, pageSize };
    this.getList(params);
  };

  getList = pageInfo => {
    // 获取详情
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "evaluateSetting/fetchGroupList",
      payload: {
        projectId: currentProjectId,
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  // 展示成员modal逻辑处理
  handleShowMemberModal = ({ visible, record }) => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    const { userGroupId } = record;
    dispatch({
      type: "evaluateSetting/fetchGroupMemberList",
      payload: {
        userGroupId,
        projectId: currentProjectId
      },
      callback: () => {
        const { existedUserIds } = this.props;
        this.setState({
          showMemberModal: visible,
          currentUserGroupId: userGroupId,
          userIds: existedUserIds
        });
      }
    });
  };

  // 展示通用指标modal逻辑处理
  handleShowNormModal = ({ visible, record }) => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    const { userGroupId } = record;
    dispatch({
      type: "evaluateSetting/fetchNormTree",
      payload: {
        projectId: currentProjectId,
        userGroupId
      },
      callback: () => {
        const { tree } = this.props;
        this.setState({
          currentUserGroupId: userGroupId
        });
        if (!tree) {
          message.info("请先设置评估指标");
        } else {
          this.setState({
            showNormModal: visible
          });
        }
      }
    });
  };

  // 展示个性化指标modal逻辑处理
  handleShowPersonalNormModal = ({ visible, record }) => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    const { userGroupId } = record;
    dispatch({
      type: "evaluateSetting/fetchGetPersonalTargetList",
      payload: {
        projectId: currentProjectId,
        userGroupId
      },
      callback: () => {
        this.setState({
          currentUserGroupId: userGroupId,
          showPersonalNormModal: visible
        });
      }
    });
  };

  // 展示评估对象modal逻辑处理
  handleShowTargetModal = ({ visible, record }) => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    const { userGroupId } = record;
    dispatch({
      type: "evaluateSetting/fetchGroupOrgList",
      payload: {
        projectId: currentProjectId,
        userGroupId
      },
      callback: () => {
        this.setState({
          showTargetModal: visible,
          currentUserGroupId: userGroupId
        });
      }
    });
  };

  // 新增modal展示处理
  handleShowAddModal = ({ isAdd, formData = { type: "", name: "" } }) => {
    this.setState({
      isAdd,
      formData,
      showAddModal: true
    });
  };

  // 评估组重命名逻辑处理
  handleRename = ({ visible = false, record = {}, event } = {}) => {
    if (event) {
      event.stopPropagation();
    }

    const { groupName, userGroupId } = record;

    this.setState({
      isAdd: false,
      showAddModal: visible,
      currentUserGroupId: userGroupId,
      formData: {
        name: groupName
      }
    });
  };

  // 添加一个指标
  handleAdd = ({ name }) => {
    //
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "evaluateSetting/fetchAddGroup",
      payload: {
        projectId: currentProjectId,
        groupName: name
      },
      callback: this.getList
    });
    this.setState({
      showAddModal: false
    });
  };

  // 新增|编辑 逻辑处理
  handleEdit = ({ name }) => {
    const { currentProjectId, currentUserGroupId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "evaluateSetting/fetchRenameGroup",
      payload: {
        projectId: currentProjectId,
        groupName: name,
        userGroupId: currentUserGroupId
      },
      callback: this.getList
    });
    this.setState({
      showAddModal: false
    });
  };

  // 跳转评估进度
  handleJump = record => {
    const { userGroupId } = record; // 评估组Id
    const { currentProjectId } = this.state;
    router.push(
      `/supervision/norm/project/overview/evaluateProcess?${stringify({
        currentProjectId,
        groupId: userGroupId
      })}`
    );
  };

  // 删除
  handleDelete = record => {
    const { userGroupId } = record;
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    confirm({
      title: "删除评估组",
      content: "确定删除该评估组吗？",
      okText: "确认",
      cancelText: "取消",
      onOk: () => {
        dispatch({
          type: "evaluateSetting/fetchDeleteGroup",
          payload: {
            projectId: currentProjectId,
            userGroupId
          },
          callback: this.getList
        });
      }
    });
  };

  // 设置评估组人员
  handleSelectMember = values => {
    const { dispatch } = this.props;
    const { currentProjectId, currentUserGroupId } = this.state;
    dispatch({
      type: "evaluateSetting/fetchSetEvaluateMember",
      payload: {
        userIds: values,
        projectId: currentProjectId,
        userGroupId: currentUserGroupId
      }
    });
    this.setState({
      showMemberModal: false
    });
  };

  // 设置评估对象
  handleSelectTarget = values => {
    const { dispatch } = this.props;
    const { currentProjectId, currentUserGroupId } = this.state;
    dispatch({
      type: "evaluateSetting/fetchSetSuperviseList",
      payload: {
        orgIds: values,
        projectId: currentProjectId,
        userGroupId: currentUserGroupId
      }
    });
    this.setState({
      showTargetModal: false
    });
  };

  // 设置通用评估指标
  handleSelectNorm = checkedKeys => {
    const { dispatch } = this.props;
    const { currentProjectId, currentUserGroupId } = this.state;
    dispatch({
      type: "evaluateSetting/fetchSetGroupNorm",
      payload: {
        projectId: currentProjectId,
        userGroupId: currentUserGroupId,
        indexCodeList: checkedKeys
      }
    });
    this.setState({
      showNormModal: false
    });
  };

  // 设置个性化评估指标
  handleSelectPersonalNorm = orgIndexList => {
    const { dispatch } = this.props;
    const { currentProjectId, currentUserGroupId } = this.state;
    dispatch({
      type: "evaluateSetting/fetchSetPersonalNorm",
      payload: {
        projectId: currentProjectId,
        userGroupId: currentUserGroupId,
        orgIndexList
      }
    });
    this.setState({
      showPersonalNormModal: false
    });
  };

  // 新增|编辑 modal
  renderEditModal = () => {
    const { showAddModal, isAdd, formData } = this.state;

    const editProps = {
      visible: true,
      title: isAdd ? "添加评估组" : "编辑模版",
      onCancel: () => this.setState({ showAddModal: false }),
      onOk: isAdd ? this.handleAdd : this.handleEdit,
      data: formData
    };
    return showAddModal && <EditModal {...editProps} />;
  };

  // 项目成员modal
  renderMemberModal = () => {
    const { groupMemberList, existedUserIds } = this.props;
    const memberProps = {
      onCancel: () => this.setState({ showMemberModal: false }),
      onOk: this.handleSelectMember,
      groupMemberList,
      selectedUserIds: existedUserIds
    };
    return <MemberModal {...memberProps} />;
  };

  // 通用指标modal
  renderOrgModal = () => {
    const orgProps = {
      onCancel: () => this.setState({ showNormModal: false }),
      onOk: this.handleSelectNorm
    };
    return <NormModal {...orgProps} />;
  };

  // 个性化指标modal
  renderPersonalOrgModal = () => {
    const { currentUserGroupId, currentProjectId, showPersonalNormModal } = this.state;
    const orgProps = {
      onCancel: () => this.setState({ showPersonalNormModal: false }),
      onOk: this.handleSelectPersonalNorm,
      currentProjectId,
      currentUserGroupId
    };
    return showPersonalNormModal && <PersonalNormModal {...orgProps} />;
  };

  // 评估对象modal
  renderTargetModal = () => {
    const { existedOrgIds, orgList } = this.props;
    const targetProps = {
      onCancel: () => this.setState({ showTargetModal: false }),
      onOk: this.handleSelectTarget,
      selectedTargetIds: existedOrgIds,
      orgList
    };
    return <TargetModal {...targetProps} />;
  };

  render() {
    const {
      showMemberModal,
      showNormModal,
      showPersonalNormModal,
      showTargetModal,
      columns
    } = this.state;
    const { spinProps, groupList, pageInfo } = this.props;
    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };

    const pageProps = {
      spinProps,
      className: styles.evaluate
    };

    const tableProps = {
      columns,
      rowKey: "userGroupId",
      list: groupList,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };

    return (
      <Container {...containerProps}>
        <ListPage {...pageProps}>
          <div className="container">
            <div className="header">
              <Button
                type="primary"
                onClick={() => this.handleShowAddModal({ isAdd: true })}
              >
                + 添加评估组
              </Button>
            </div>
          </div>
          <ListTable {...tableProps} />
          {this.renderEditModal()}
          {showMemberModal && this.renderMemberModal()}
          {showNormModal && this.renderOrgModal()}
          {showPersonalNormModal && this.renderPersonalOrgModal()}
          {showTargetModal && this.renderTargetModal()}
        </ListPage>
      </Container>
    );
  }
}

export default EvaluateSettingView;
